import { database } from '../index';
import { INVENTORY_SCHEMA, INVOICE_SCHEMA, PAYMENT_SCHEMA, STOCK_SCHEMA } from '../schema';
import { uuid } from '../../oscar-pos-core/constants';
import { Q } from '@nozbe/watermelondb';
import { getStockByID, stockCalculation } from './stock';

const inventory = database.collections.get(INVENTORY_SCHEMA)
const stockModal = database.collections.get(STOCK_SCHEMA)


export const getInvByStockID = async (id) => await inventory.query(Q.on(STOCK_SCHEMA, "id", id)).fetch();


export const bulkCreateInventory = async (items, type) => {
    await database.write(async () => {
        const allRecords = await prepareCreation(items, type);
        await database.batch(...allRecords)
    })
}

const prepareCreation = async (items, type) => {
    return await Promise.all(items.map(async item => {
        try {
            const model = await stockModal.find(item.id);
            return inventory.prepareCreate(inv => {
                inv.stock.set(model.length ? model[0] : model)
                inv._raw.id = uuid()
                inv.name = item.name
                inv.quantity = item.quantity
                inv.type = type === 'in' ? 'sales' : 'expense'
                inv.transacted_at = new Date().getTime()
            })
        } catch (err) {
        }
    }))
}

export const bulkCreateInventoryV2 = async (items, type) => {
    await database.write(async () => {
        const allRecords = await prepareCreationV2(items, type);
        await database.batch(...allRecords);
    });
};

const prepareCreationV2 = async (items, type) => {
    return await Promise.all(items.map(async item => {
        try {
            const model = await stockModal.find(item.id);
            return item.stock ? inventory.prepareCreate(inv => {
                inv.stock.set(model);
                inv.is_secondary_unit = item.is_secondary_unit;
                inv.price = item?.price || item.cost_price;
                inv.unit_conversion = item.unit_conversion;
                inv.transacted_at = new Date().getTime();
                inv.quantity = item.stock;
                inv._raw.id = uuid();
                inv.name = item.name;
                inv.type = type;
            }) : null
        } catch (err) {
            console.error("Failed to prepare inventory:", err, item);
            return null; // explicitly return null instead of undefined

        }
    }));
};





export const bulkUpdateInventory = async (business, invoice, items, type, origin) => {
    await database.write(async () => {
        const allRecords = await prepareUpdate(business, invoice, items, type, origin);
        await database.batch(...allRecords);
    });
};

const prepareUpdate = async (business, invoice, items, type, origin) => {
    return await Promise.all(items.map(async item => {
        try {

            const { original, updated } = item;

            const [stock, is_secondary] = await stockCalculation(updated);

            let salePrice = updated?.hasOwnProperty('updated_selling_price') ? updated.updated_selling_price : stock.selling_price;
            let costPrice = updated?.hasOwnProperty('updated_cost_price') ? updated.updated_cost_price : stock.cost_price;

            if (updated?.quantity === original?.quantity) return;

            let qty = Math.abs(updated?.quantity - original?.quantity);
            let reverseType = type === 'in' ? 'out' : 'in';

            const finalType = updated?.quantity < original?.quantity ? type : reverseType

            return inventory.prepareCreate(inv => {
                inv.stock.set(stock);
                inv.tran_type = origin === 'cash' ? 'cash' : origin == 'invoice' ? 'invoice' : origin == 'pos' ? 'pos' : origin == 'payment' ? 'account' : null;
                inv.table_name = (origin === 'invoice' || origin === 'cash' || origin === 'pos') ? INVOICE_SCHEMA : origin == 'payment' ? PAYMENT_SCHEMA : null;
                inv.price = finalType === 'in' ? costPrice : salePrice;
                inv.unit_conversion = stock?.unit_conversion || null;
                inv.transacted_at = new Date().getTime();
                inv.refrence_id = invoice?.id || null;
                inv.is_secondary_unit = is_secondary;
                inv.name = stock.name;
                inv.type = finalType;
                inv._raw.id = uuid();
                inv.quantity = qty;
            });

        } catch (err) {
            console.log('ERROR: CREATING-INVENTORY', err)
        }
    }));
};


export const bulkCreateInventoryV3 = async (business, invoice, items, type, origin, ordersByItemId) => {
    await database.write(async () => {
        const allRecords = await prepareCreationV3(business, invoice, items, type, origin, ordersByItemId);
        await database.batch(...allRecords);
    });
};

const prepareCreationV3 = async (business, invoice, items, type, origin, ordersByItemId) => {
    return await Promise.all(items.map(async item => {
        try {

            if (item?.is_open_item) return;

            const [stock, is_secondary] = await stockCalculation(item);

            let salePrice = item?.hasOwnProperty('updated_selling_price') ? item.updated_selling_price : stock.selling_price;
            let costPrice = item?.hasOwnProperty('updated_cost_price') ? item.updated_cost_price : stock.cost_price;
            const order = ordersByItemId?.[item.id];

            return inventory.prepareCreate(inv => {
                inv.stock.set(stock);
                if (order) inv.orders.set(order);
                inv.tran_type = origin === 'cash' ? 'cash' : origin == 'invoice' ? 'invoice' : origin == 'pos' ? 'pos' : origin == 'payment' ? 'account' : null;
                inv.table_name = (origin === 'invoice' || origin === 'cash' || origin === 'pos') ? INVOICE_SCHEMA : origin == 'payment' ? PAYMENT_SCHEMA : null;
                inv.unit_conversion = stock?.unit_conversion || null;
                inv.price = type === 'in' ? costPrice : salePrice;
                inv.transacted_at = new Date().getTime();
                inv.refrence_id = invoice?.id || null;
                inv.is_secondary_unit = is_secondary;
                inv.quantity = item.quantity;
                inv.name = stock.name;
                inv._raw.id = uuid();
                inv.type = type;
            })
        } catch (err) {
            console.log('ERROR: CREATING-INVENTORY', err)
        }
    }));
};



export const bulkDeleteInventory = async (invoice, items, type, origin) => {
    await database.write(async () => {
        const allRecords = await prepareDeletion(invoice, items, type, origin);
        await database.batch(...allRecords);
    });
};

const prepareDeletion = async (invoice, items, type, origin) => {
    return await Promise.all(items.map(async item => {
        try {

            const { original, updated } = item;

            if (original?.is_open_item) return;

            let stock = await getStockByID(updated.id);
            return inventory.prepareCreate(inv => {
                inv.stock.set(stock);
                inv.tran_type = origin === 'cash' ? 'cash' : origin == 'invoice' ? 'invoice' : origin == 'pos' ? 'pos' : origin == 'payment' ? 'account' : null;
                inv.table_name = (origin === 'invoice' || origin === 'cash' || origin === 'pos') ? INVOICE_SCHEMA : origin == 'payment' ? PAYMENT_SCHEMA : null;
                inv.price = type === 'in' ? original.cost_price : original.selling_price;
                inv.unit_conversion = stock?.unit_conversion || null;
                inv.is_secondary_unit = original.is_secondary_unit;
                inv.transacted_at = new Date().getTime();
                inv.refrence_id = invoice?.id || null;
                inv.quantity = original.quantity;
                inv.name = stock.name;
                inv._raw.id = uuid();
                inv.type = type;
            })
        } catch (err) {
            console.log('ERROR: CREATING-INVENTORY', err)
        }
    }));
};